module.exports = __webpack_public_path__ + "img/statement.a67499d9.svg";